import React from 'react';

export default function StarRating({ value = 0, onChange, label, readOnly = false, size = 'md' }) {
  const stars = [1, 2, 3, 4, 5];
  const sizeClasses = { sm: 'rt-star-sm', md: 'rt-star-md', lg: 'rt-star-lg' };

  return (
    <div className="rt-star-rating">
      {label && <span className="rt-star-label">{label}</span>}
      <div className={`rt-stars ${sizeClasses[size] || sizeClasses.md}`}>
        {stars.map((star) => (
          <button
            key={star}
            type="button"
            className={`rt-star ${star <= value ? 'rt-star-filled' : 'rt-star-empty'}`}
            onClick={readOnly ? undefined : () => onChange(star)}
            disabled={readOnly}
            aria-label={`${star} star${star > 1 ? 's' : ''}`}
            data-testid={label ? `rt-star-${label.toLowerCase().replace(/\s+/g, '-')}-${star}` : `rt-star-${star}`}
          >
            {star <= value ? '★' : '☆'}
          </button>
        ))}
        {readOnly && value > 0 && <span className="rt-star-value">{Number(value).toFixed(1)}</span>}
      </div>
    </div>
  );
}

export function RatingBar({ label, value, maxValue = 5 }) {
  const pct = (value / maxValue) * 100;
  const color = value >= 4 ? '#22c55e' : value >= 3 ? '#D4A24C' : value >= 2 ? '#f97316' : '#ef4444';

  return (
    <div className="rt-rating-bar">
      <div className="rt-rating-bar-header">
        <span className="rt-rating-bar-label">{label}</span>
        <span className="rt-rating-bar-value">{value}/5</span>
      </div>
      <div className="rt-rating-bar-track">
        <div className="rt-rating-bar-fill" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
    </div>
  );
}
